import * as tslib_1 from "tslib";
import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { fileToBase64 } from '@core/utils/file-converter';
import { toImageSize } from '@core/utils/to-Image-size';
import { TranslateService } from '@ngx-translate/core';
import compress from 'browser-image-compression';
import { v4 as uuid } from 'uuid';
import { ViewQrCodeModalService } from '../../../../../core/components/view-qr-code-modal/view-qr-code-modal.service';
var TabNewGeneralComponent = /** @class */ (function () {
    function TabNewGeneralComponent(translateService, messageService, videoInfoModalService, viewQrCodeModalService) {
        this.translateService = translateService;
        this.messageService = messageService;
        this.videoInfoModalService = videoInfoModalService;
        this.viewQrCodeModalService = viewQrCodeModalService;
    }
    TabNewGeneralComponent.prototype.selectPicture = function ($event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, picture, maxSize, hasInvalidType, hasInvalidSize, message, base64Picture, _b, width, height, compressedPicture;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.equipmentForm.get('imageUrl').setErrors(null);
                        _a = tslib_1.__read($event.target.files, 1), picture = _a[0];
                        maxSize = 2 * 1024 * 1024;
                        if (!picture) {
                            return [2 /*return*/];
                        }
                        hasInvalidType = !['image/jpg', 'image/jpeg', 'image/png'].includes(picture.type);
                        hasInvalidSize = !(picture.size && picture.size <= maxSize);
                        if (hasInvalidType || hasInvalidSize) {
                            message = "EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.ERRORS." + (hasInvalidType ? 'INVALID_TYPE' : 'INVALID_SIZE');
                            this.messageService.error(message);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fileToBase64(picture)];
                    case 1:
                        base64Picture = _c.sent();
                        return [4 /*yield*/, toImageSize(base64Picture)];
                    case 2:
                        _b = _c.sent(), width = _b.width, height = _b.height;
                        if (width < 512 || height < 512) {
                            this.messageService.error('EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.ERRORS.INVALID_DIMENSIONS');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, compress(picture, { maxSizeMB: maxSize, maxWidthOrHeight: 1920 })];
                    case 3:
                        compressedPicture = _c.sent();
                        this.equipmentForm.get('imageUrl').setValue({
                            thumb: base64Picture,
                            file: compressedPicture,
                            filename: picture.name,
                            size: compressedPicture.size,
                            type: picture.type
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabNewGeneralComponent.prototype.removePicture = function () {
        this.equipmentForm.get('imageUrl').setValue(null);
        this.pictureInput.nativeElement.value = '';
    };
    TabNewGeneralComponent.prototype.generateQrCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.equipmentForm.get('qrCode').setValue(uuid());
                this.openQrCodeDialog();
                this.messageService.success('EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.QR_CODE.SUCCESS');
                return [2 /*return*/];
            });
        });
    };
    TabNewGeneralComponent.prototype.openQrCodeDialog = function () {
        this.viewQrCodeModalService.open({
            qrCode: this.equipmentForm.get('qrCode').value,
            fileName: this.equipmentForm.get('name').value
        });
    };
    TabNewGeneralComponent.prototype.openDemonstrationVideoDialog = function () {
        this.videoInfoModalService.open({
            title: this.translateService.instant('EQUIPMENTS.DIALOG.NEW_GENERAL.FEATURE.INTRO_VIDEO.TITLE'),
            description: this.translateService.instant('EQUIPMENTS.DIALOG.NEW_GENERAL.FEATURE.INTRO_VIDEO.DESCRIPTION'),
            videoId: 'VQE_FyV8Gf0'
        });
    };
    return TabNewGeneralComponent;
}());
export { TabNewGeneralComponent };
